import { Link } from 'react-router-dom';
import Vib3Mark from './Vib3Mark';

/**
 * Landing footer, shared by the landing page and the legal documents.
 * Links are limited to the internal pages (Privacy, Terms).
 */
export default function LandingFooter() {
  return (
    <footer>
      <div className="foot-in">
        <Link to="/" className="foot-brand"><span className="mark"><Vib3Mark /></span>Vib3</Link>
        <div className="foot-links">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>
        <p>© 2026 · Express business audit</p>
      </div>
    </footer>
  );
}
